var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.script)?_c('script-content',{attrs:{"script":_vm.script}}):_c('div',{staticClass:"pa-4"},[_vm._v("Loading script…")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }